import segment from './segment';
import dashboard from './dashboard';
import analytics from './analytic';
import dataConnect from './data-connect';
import communication from './communication';
import mka from './mka';
import report from './report';
import setting from './setting';

const verticalMenuList = [...dashboard, ...segment, ...analytics, ...dataConnect, ...communication, ...mka];

export default verticalMenuList;
